import { Input, Label } from '@onwardtravelsolutions/package-react/Components';
import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';

type CheckboxFieldProps = {
    id: string;
    children: React.ReactNode;
    label?: string;
    status?: ValidationStatus;
    isDirty?: boolean;
    setValue?: (value: any) => void;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function CheckboxField({
    id,
    status,
    children = null,
    isDirty = false,
    setValue = null,
    onChange = null,
    ...rest
}: CheckboxFieldProps) {
    return (
        <Label
            {...{
                fieldId: `field-${id}`,
                className: `flex items-center dark:text-gray-100 p-2 w-full mb-0`,
            }}
        >
            <Input
                {...{
                    id: `field-${id}`,
                    type: 'checkbox',
                    className: 'mr-2',
                    onChange:
                        onChange ??
                        ((event: React.ChangeEvent<HTMLInputElement>) =>
                            setValue && setValue(event.currentTarget.value)),
                    ...rest,
                }}
            />
            {children}
        </Label>
    );
}
